var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{style:({ width: '100%' }),attrs:{"src":_vm.url,"alt":"图片","referrerpolicy":"no-referrer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }